export default __webpack_public_path__ + "static/media/doc_file.88b9b7a6.png";